export const PARTICIPANT_TYPE_TENANT_LABEL = 'Tenant';
export const PARTICIPANT_TYPE_TENANT_ID = '507f1f77bcf86cd799439010';
